import React from "react"
import styles from "./formGrid.module.css"

const FormGrid = ({ children, className = "", style = {} }) => (
    <div className={`${styles.grid} ${className}`.trim()} style={style}>
        {children}
    </div>
)

export default FormGrid
